import axios from 'axios';
import keycloak from '../utils/keycloakauth';
import { API_BASE_URL } from '../utils/config';

const BASE_URL = API_BASE_URL;

// Get available team members from the same tenant
export const getAvailableMembers = async () => {
  try {
    if (!keycloak.authenticated) {
      throw new Error('User is not authenticated');
    }
    const token = keycloak.token;
    const response = await axios.get(`${BASE_URL}/api/teams/available-members`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get available members:', error);
    throw error;
  }
};

// Get current team members
export const getTeamMembers = async () => {
  try {
    if (!keycloak.authenticated) {
      throw new Error('User is not authenticated');
    }
    const token = keycloak.token;
    const response = await axios.get(`${BASE_URL}/api/teams/members`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to get team members:', error);
    throw error;
  }
};

// Invite a team member (tenant-aware)
export const inviteTeamMember = async (email, accessLevel) => {
  try {
    if (!keycloak.authenticated) {
      throw new Error('User is not authenticated');
    }
    const token = keycloak.token;
    const response = await axios.post(
      `${BASE_URL}/api/teams/invite`,
      {
        email,
        access_level: accessLevel,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Failed to invite team member:', error);
    // Handle specific error cases from API
    if (error.response?.status === 400) {
      const errorDetail = error.response.data?.detail;
      if (errorDetail?.includes('same domain')) {
        throw new Error('Can only invite users from the same domain');
      } else if (errorDetail?.includes('not authorized')) {
        throw new Error('User is not authorized in your tenant. Please ask your admin to authorize them first.');
      } else if (errorDetail?.includes('already invited')) {
        throw new Error('User already invited to team');
      }
    }
    throw error;
  }
};

// Update team member access level
export const updateMemberAccess = async (memberId, accessLevel) => {
  try {
    if (!keycloak.authenticated) {
      throw new Error('User is not authenticated');
    }
    const token = keycloak.token;
    const response = await axios.put(
      `${BASE_URL}/api/teams/members/${memberId}/access?access_level=${accessLevel}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Failed to update member access:', error);
    throw error;
  }
};

// Remove team member
export const removeTeamMember = async (memberId) => {
  try {
    if (!keycloak.authenticated) {
      throw new Error('User is not authenticated');
    }
    const token = keycloak.token;
    const response = await axios.delete(`${BASE_URL}/api/teams/members/${memberId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to remove team member:', error);
    throw error;
  }
};